import { useQuery } from 'react-query';
import {
  CustomerCompanyService,
  Wealthlane_CustomerService_Dtos_VendorCompany_CustomerCompayDetailDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetCompanyProfileDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  hasPermission?: boolean
) => {
  const companyProfileDetailsData = useQuery(
    ['companyProfileDetails'],
    async () => {
      if (hasPermission ?? false) {
        return await handleRequest(
          CustomerCompanyService.getApiCustomerApiAppCustomerCompanyCompanyDetailForView()
        );
      }
    },

    {
      cacheTime: 1000 * 60 * 5,
      refetchOnWindowFocus: 'always',
      select: (data) => {
        if (data != null) {
          return {
            ...data,
            companyAddressList:
              data?.companyAddressList != null && data?.companyAddressList?.length > 0
                ? data.companyAddressList
                : [
                    {
                      countryId: null,
                      countryText: '',
                      addressLine1: '',
                      addressLine2: '',
                      stateId: null,
                      cityText: '',
                      stateText: '',
                      zipCode: '',
                      taxId: null,
                      id: null,
                    },
                  ],
          };
        }
      },
    }
  );

  return companyProfileDetailsData;
};

export default useGetCompanyProfileDetails;
